import { X } from 'lucide-react'
import DateRangePicker from '../roomDetails/booking/DateRangePicker'

interface CalendarModalProps {
  isOpen: boolean
  onClose: () => void
  checkIn: string
  checkOut: string
  onDateChange: (name: string, value: string) => void
}

const CalendarModal = ({ isOpen, onClose, checkIn, checkOut, onDateChange }: CalendarModalProps) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between z-10">
          <h2 className="text-2xl font-bold text-gray-900">Select Dates</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            aria-label="Close"
          >
            <X className="h-6 w-6 text-gray-600" />
          </button>
        </div>

        {/* Calendar Content */}
        <div className="p-6">
          <DateRangePicker
            checkIn={checkIn}
            checkOut={checkOut}
            nights={checkIn && checkOut 
              ? Math.ceil((new Date(checkOut).getTime() - new Date(checkIn).getTime()) / (1000 * 60 * 60 * 24))
              : 0
            }
            errors={{}}
            onChange={onDateChange}
            showHeading={false}
            isOpen={true}
            onClose={onClose}
          />
        </div>

        {/* Footer Actions */}
        <div className="sticky bottom-0 bg-white border-t border-gray-200 px-6 py-4 flex items-center justify-end gap-3">
          <button
            onClick={() => {
              onDateChange('checkIn', '')
              onDateChange('checkOut', '')
            }}
            className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors font-medium"
          >
            Clear
          </button>
          <button
            onClick={onClose}
            className="px-6 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 transition-colors font-semibold"
          >
            Apply Dates
          </button>
        </div>
      </div>
    </div>
  )
}

export default CalendarModal





























